import { useEffect } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const ImportFteModalPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const { canSeeFinanceWorkspace } = useOutletContext<{
    canSeeFinanceWorkspace: boolean
  }>()

  const {
    access: { locale },
    company: { id: companyId },
  } = useCurrentSession()

  const onClose = useUnsafeCallback(() => {
    navigate(navigation.finance.financialWorkspace.employee_costs.fullPath())
  }, [navigate, navigation])

  const footer = useUnsafeCallback(() => {
    return (
      <Button onClick={onClose} type="secondary">
        {i18n.t('common.cancel')}
      </Button>
    )
  }, [onClose])

  useEffect(() => {
    if (!canSeeFinanceWorkspace) {
      onClose()
    }
  }, [canSeeFinanceWorkspace, onClose])

  if (!canSeeFinanceWorkspace) {
    return null
  }

  return (
    <Modal
      footer={footer()}
      disableFocusTrap
      onClose={onClose}
      illustration="table-file"
      title={i18n.t('finance.financial_workspace.employee_costs.workforce.fte_review_modal_title')}
    >
      <NuvoImporter
        isEdition
        locale={locale}
        companyId={companyId}
        importType="working_time_percentage_importer"
      />
    </Modal>
  )
}

export default ImportFteModalPage
